import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React, { useContext } from 'react';
import Block from 'wfui-digital-core/es/Block';
import StickyFooterContext from '../../../context/StickyFooterContext';
import FooterLink from './footer-link/FooterLink';
import styles from './Footer.less';

var Footer = function Footer() {
  var _useContext = useContext(StickyFooterContext),
      menuConfig = _useContext.menuConfig;

  var linkSections = menuConfig.sections[1].sections.filter(function (_ref) {
    var type = _ref.type;
    return type === 'LINKS';
  });
  var links = linkSections.slice(-1)[0].links;
  return /*#__PURE__*/React.createElement(Block, {
    pt: "s",
    layout: true,
    vertical: true,
    flex: true,
    className: styles.footer
  }, links.map(function (link, index) {
    return /*#__PURE__*/React.createElement(FooterLink, {
      key: index,
      link: link
    });
  }));
};

export default Footer;